import request from '../../utils/request';
import { stringify } from 'qs';

export async function addWatchRecord(params) {
  return request(`/api/blade-system/watch-record/submit`, {
    method: 'POST',
    body: params,
  });
}

export async function watchRecordDetail(params) {
  return request(`/api/blade-system/watch-record/detail?${stringify(params)}`);
}

export async function queryWatchRecord(params) {
  return request(`/api/blade-system/watch-record/getWatchPercentPage?${stringify(params)}`);
}

export async function addVisitorRecord(params) {
  return request(`/api/blade-system/page/visitor?${stringify(params)}`, {
    method: 'POST',
  });
}
